module.exports = __webpack_public_path__ + "img/159.8b855250.jpg";